 'use strict';
	
$(function(){

	// INIT AOS
 	AOS.init();
	 
	// FANCYBOX DEFAULTS
	$.fancybox.defaults.closeExisting = true;

	// REMOVE .is-loading
	$(window).on('load', function () {
		$('html').removeClass('is-loading');
	});
	
	// SCROLL TO LINK
	$(document).on('click', 'a[href^="#"]', function(e){
		var elem_href = $(this).attr('href');

		// ONE TRUST COOKIE SETTINGS
		if( elem_href == '#cookie-settings' ) {
			e.preventDefault();
			$('.ot-floating-button__open').trigger('click');
		} else {
			var $target = elem_href == '#' ? [] : $(elem_href);
			if( elem_href !== '#' && $target.length > 0 && ! $(this).is('[data-fancybox]') ) {
				e.preventDefault();
				if( ! $target.is(':visible') && $target.closest('.tab-content').length > 0 ) {
					tab_to_section( '#' + $target.closest('.tab-content').attr('id'), true );
				}

				smooth_scroll( $target );
			}
		}
	});
	
	// FANCYBOX BIO LAUNCH
	$('[data-fancybox-bio]').on('click', function(){
		setTimeout(function(){
			$(window).trigger('resize');
		}, 150)
	})

	// SUBNAV HANDLING
	$('[data-sub-sub-nav-trigger]').on('mouseenter', function(){
		$('[data-sub-sub-nav-trigger]').removeClass('hover').filter(this).addClass('hover');
		$('[data-sub-sub-nav]').hide().filter('[data-sub-sub-nav="' + $(this).attr('data-sub-sub-nav-trigger') + '"]').show();
	});
	$('.subnav').on('mouseleave', function(){
		$('[data-sub-sub-nav-trigger]').removeClass('hover');
		$('[data-sub-sub-nav]').hide();
	});
	
	// MOUSEOVER HANDLING
	$('.nav-industry').on('mouseenter', function(){
		if( w.width >= 1200 ) {
			$('.nav-industry').addClass('nav-industry-hover');
		}
	}).on('mouseleave', function(){
		if( w.width >= 1200 ) {
			$('.nav-industry').removeClass('nav-industry-hover');
		}
	});

	// NAV INDUSTRY HANDLING
	$('.nav-industry-header').on('click', function(e){
		e.preventDefault();
		if( ! $('.nav-industry').is('.nav-industry-hover') ) {
			$('.nav-industry').addClass('nav-industry-hover');
		}
	})
	
	// CLOSE MODAL CONTENT
	$('[data-nav-industry-close]').on('click', function(e){
		e.preventDefault();
		$('.nav-industry').removeClass('nav-industry-hover');
	})
	
	// CHANGE INDUSTRY
	$('[data-nav-industry-change-industry]').on('click', function(e){
		e.preventDefault();
		$('body').removeClass('user-industry-set');
		$('.nav-industry-dropdown-industry-content').html('');
		user_data.industry = false;
		browser_storage_set( 'user_data', JSON.stringify( user_data ) );
	})
	
	// OPEN MODAL MENU
	$('[data-menu-open]').on('click', function(e){
		e.preventDefault();
		$('body').addClass('mobile-menu-open');
		$(window).trigger('resize');
	})
	
	// CLOSE MODAL MENU
	$('[data-menu-close]').on('click', function(e){
		e.preventDefault();
		$('body').removeClass('mobile-menu-open');
	})
	
	// SWITCH BETWEEN MOBILE MENU ITEMS
	$('[data-menu-key-to]').on('click', function(e){
		e.preventDefault();
		$('[data-menu-key]').removeClass('active').filter('[data-menu-key="' + $(this).attr('data-menu-key-to') + '"]').addClass('active');
	})
	
	// REDIRECT SELECT FIELDS
	$(document).on('change', '[data-redirect-select]', function(e){
		e.preventDefault();
		window.location.href = $(this).find('option[value="' + $(this).val() + '"]').attr('data-redirect');
	})
	
	// EXPAND/COLLAPSE MOBILE MENU
	$('[data-menu-mobile-expand]').on('click', function(e){
		e.preventDefault();

		if( ! $(this).closest('li.has-children').is('.is-open') ) {
			$('.footer-link-wrapper li.has-children').removeClass('is-open');
			$(this).closest('li.has-children').addClass('is-open')
		} else {
			$('.footer-link-wrapper li.has-children').removeClass('is-open');
		}
		$(window).trigger('resize');
	})
	
	// WRAP ENGINEERING IMAGES IN FANCYBOX
	$('.nav-sidebar-content-inner .cms img').each(function(){
		if( $(this).closest('a').length == 0 ) {
			var src;
			if( $(this).attr('srcset') ) {
				var srcset = $(this).attr('srcset');
				var srcset_items = srcset.split(', ');
				src = srcset_items[srcset_items.length - 1].split(' ')[0];
			}
			if( ! src && $(this).attr('src') ) {
				src = $(this).attr('src')
			}
			if( src ) {
				$(this).wrap('<a href="' + src + '" class="border-top-bottom-left-right ' + $(this).attr('class') + '" data-fancybox="support"></a>');
			}
		}
	})
	
	// PRODUCT PAGE - SHOW RETURN TO PRODUCT FINDER IF REFERRER MATCHES PRODUCT FINDER PAGE
	if( $('body').is('.single-product') ) {
		if( document.referrer.indexOf('/product-finder/') !== -1 ) {
			$('.return-to-product-finder').attr('href', document.referrer);
		} else if( document.referrer.indexOf('/browse/') !== -1 ) {
			$('.return-to-product-finder').attr('href', document.referrer);
		} else if( user_data.industry ) {
			var ajax_data = {
				'industry' 		: user_data.industry.id,
				'product_type'	: $('.section--product-top').attr('data-product-type'),
				'action'		: 'get-product-browse-link'
			};
			$.ajax({
				url: "/wp-admin/admin-ajax.php",
				type: "POST",
				data: ajax_data,
				success: function (result) {
					if( result != 0 ) {
						$('.return-to-product-finder').attr('href', result);
					}
				}
			})
		}
	}
	
	// SOCIAL
	$(document).on('click', '.share', function(e) {
		$(this).share_popup(e);
	});
	
	$(document).on('click', '.fb-share-button', function(e){
		e.preventDefault();
		FB.ui({
			method: 'share',
			href: $(this).data('href'),
		}, function(response){});
	});
	
	
	// TABS
	
	var tab_to_section = function( tab, stop_scroll ) {
		tab = '#' + tab.split('#').join('');
		let $target = $(tab);
		let $tab_toggle = $('.tab-toggle[href="' + tab + '"]');
		let $tab_accordion_toggle = $('.tab-accordion-toggle[href="' + tab + '"]');
		let $tab_section = $target.closest('.tab-section');

		let tab_hash = $target.attr('data-tab-hash') ? $target.attr('data-tab-hash') : tab;

		var is_active = $target.is('.active');
		let is_accordion = $tab_section.find('.tab-accordion-toggle:first').is(':visible');
		
		if( is_accordion && is_active ) {
			$tab_section.find('.tab-toggle,.tab-accordion-toggle,.tab-content').removeClass('active');
			history.pushState( null, null, '#' );
			$(window).trigger('resize');
			return;
		}
		
		if( ! is_active ) {
			$tab_section.find('.tab-toggle,.tab-accordion-toggle,.tab-content').removeClass('active');

			$target.add($tab_toggle).add($tab_accordion_toggle).addClass('active');

			if( ! is_accordion && stop_scroll !== true ) {
				smooth_scroll( $tab_section );
			} else if( is_accordion ) {
				smooth_scroll( $tab_accordion_toggle, 0 );
			}

			if( swipers && $target.find('.swiper-container').length ) {
				$.each(swipers, function(key, swiper){
					swiper.update();
				})
			}

			history.pushState( null, null, tab_hash );

			$(window).trigger('resize');
		}
	}
	
	// INITIATE TABS
		// WATCH HANDLES
		$(document).on('click', '.tab-toggle, .tab-accordion-toggle', function(){
			tab_to_section( $(this).attr('href') );
		})
		// COLLAPSE TABS BY DEFAULT ON MOBILE
		if( window.outerWidth < 992 ) {
			$('.tab-toggle,.tab-accordion-toggle,.tab-content').removeClass('active');
		}
		// INITIAL TAB
		$(document).ready(function(){
			if( window.location.hash ) {
				tab_to_section(window.location.hash);
			}
		})

	// FAQ ACCORDION
	$(document).on('click', '.faq-item__question', function(){
		var $item = $(this).closest('.faq-item');
		var is_active = $item.hasClass('active');

		if( is_active ) {
			$item.removeClass('active');
			$item.find('.faq-item__answer').slideUp();
		} else {
			$item.addClass('active');
			$item.find('.faq-item__answer').slideDown();
		}

		$(this).attr('aria-expanded', ! is_active);
	});

	// FAQ THUMBS UP
	var FAQ_THUMBS_UP_STORAGE_KEY = 'lee_faq_thumbs_up';

	function getVotedFaqIds() {
		try {
			var raw = window.localStorage.getItem( FAQ_THUMBS_UP_STORAGE_KEY );
			var parsed = raw ? JSON.parse( raw ) : [];
			return Array.isArray( parsed ) ? parsed.map( String ) : [];
		} catch( e ) {
			return [];
		}
	}

	function rememberFaqVote( faqId ) {
		try {
			var voted = getVotedFaqIds();
			if( voted.indexOf( String( faqId ) ) === -1 ) {
				voted.push( String( faqId ) );
				window.localStorage.setItem( FAQ_THUMBS_UP_STORAGE_KEY, JSON.stringify( voted ) );
			}
		} catch( e ) {}
	}

	// Mark previously-voted FAQs on load
	$(function(){
		var voted = getVotedFaqIds();
		if( ! voted.length ) return;
		$('.faq-item').each(function(){
			var faqId = String( $(this).attr('data-faq-id') || '' );
			if( faqId && voted.indexOf( faqId ) !== -1 ) {
				$(this).addClass('has-voted');
				$(this).find('[data-faq-thumbs-up]').attr('aria-pressed', 'true');
			}
		});
	});

	$(document).on('click', '[data-faq-thumbs-up]', function(){
		var $button = $(this);
		var $item = $button.closest('.faq-item');
		var faqId = $item.attr('data-faq-id');

		if( ! faqId || $item.hasClass('has-voted') || $button.attr('aria-pressed') === 'true' ) return;

		// Optimistic UI
		$item.addClass('has-voted');
		$button.attr('aria-pressed', 'true');
		rememberFaqVote( faqId );

		$.ajax({
			url: '/wp-admin/admin-ajax.php',
			type: 'POST',
			dataType: 'json',
			data: { action: 'faq-thumbs-up', faq_id: faqId }
		}).done(function( res ){
			if( res && res.success && typeof res.count !== 'undefined' ) {
				$item.find('[data-faq-thumbs-up-count]').text( res.count );
				$item.find('[data-faq-thumbs-up-label]').text(
					res.count === 1 ? 'Person Found This Helpful' : 'People Found This Helpful'
				);
			}
		});
	});

	// FAQ FILTERS
	function faqFilter( $section ) {
		var topicVal = $section.find('[data-faq-filter="topic"]').val();
		var industryVal = $section.find('[data-faq-filter="industry"]').val();
		var searchVal = ( $section.find('[data-faq-filter="search"]').val() || '' ).toLowerCase().trim();
		var hasActiveFilters = topicVal || industryVal || searchVal;

		$section.find('[data-faq-clear]').toggleClass( 'visible', !! hasActiveFilters );

		$section.find('.faq-topic-group').each(function(){
			var $group = $(this);
			var topicMatch = ! topicVal || $group.attr('data-faq-topic') === topicVal;

			if( ! topicMatch ) {
				$group.hide();
				return;
			}

			$group.show();

			$group.find('.faq-item').each(function(){
				var $item = $(this);
				var visible = true;

				if( industryVal ) {
					var industries = ( $item.attr('data-faq-industries') || '' ).split(',');
					if( industries.indexOf( industryVal ) === -1 ) visible = false;
				}

				if( visible && searchVal ) {
					var text = $item.text().toLowerCase();
					if( text.indexOf( searchVal ) === -1 ) visible = false;
				}

				$item.toggle( visible );
			});

			if( industryVal || searchVal ) {
				$group.toggle( $group.find('.faq-item:visible').length > 0 );
			}
		});
	}

	$(document).on('change', '[data-faq-filter="topic"], [data-faq-filter="industry"]', function(){
		faqFilter( $(this).closest('.section--faq') );
	});

	$(document).on('input', '[data-faq-filter="search"]', function(){
		faqFilter( $(this).closest('.section--faq') );
	});

	$(document).on('click', '[data-faq-clear]', function(){
		var $section = $(this).closest('.section--faq');
		$section.find('[data-faq-filter="topic"]').val('');
		$section.find('[data-faq-filter="industry"]').val('');
		$section.find('[data-faq-filter="search"]').val('');
		$section.find('.select-wrap .placeholder').each(function(){
			var $select = $(this).siblings('select');
			$(this).html( $select.find('option[value="' + $select.val() + '"]').text() );
		});
		faqFilter( $section );
	});

	// TWITTER/LINKEDIN
	$.fn.share_popup = function (e, intWidth, intHeight, blnResize) {
	
		// Prevent default anchor event
		e.preventDefault();
	
		// Set values for window
		intWidth = intWidth || '500';
		intHeight = intHeight || '400';
		strResize = (blnResize ? 'yes' : 'no');
	
		// Set title and open popup with focus on it
		var strTitle = ((typeof this.attr('title') !== 'undefined') ? this.attr('title') : 'Social Share'),
		strParam = 'width=' + intWidth + ',height=' + intHeight + ',resizable=' + strResize,			
		objWindow = window.open(this.attr('href'), strTitle, strParam).focus();
	}
	
	
	if( $('body').is('.single-insight') ) {
		if( get_url_param( 'back' ) == 'referrer' ) {
			var referrer = document.referrer;
			if( referrer.indexOf( site_url ) !== -1 ) {
				$('.btn-txt--back').attr('href', document.referrer ).text('Back');
			}
		}
	}

});

// FOOTER
	// BRING HOVERED PATH TO FRONT (z-index NOT PROCESSED IN SVG)
	$('.footer-map-pin').on('mouseover', function(){
		$('.footer-map-location').removeClass('active');
		$(this).closest('.footer-map-continent').append( $(this).closest('.footer-map-location') );
		$(this).closest('.footer-map-location').addClass('active');
	}).on('mouseout', function(){
		$(this).closest('.footer-map-location').removeClass('active');
	});
	
	// ANIMATE CIRCLE
	setInterval(function(){
		$('.footer-map-pin-animated-circle').css({
			'r'			: 3.5,
			'opacity'	: .6
		}).animate({
			'r'			: 10,
			'opacity'	: 0
		}, 2000);
	}, 3000);


$(window).on('resize', function(){
	$('[data-min-aspect-height]').each(function(){
		var aspects = [];
		
		$.each($(this).attr('data-min-aspect-height').split('|'), function(key, value){
			aspects.push( value.split(':') )
		});
		
		var current_aspect = window.outerWidth < 768 && aspects.length > 1 ? aspects[1] : aspects[0];
		
		$(this).css( 'min-height', ( ( $(this).outerWidth() * current_aspect[1] ) / current_aspect[0] ) );
	});

	$('.block-link').each(function(){
		var $p = $(this).find('.block-link-inner--hidden p');
		if( $p.length > 0 ) {
			$(this).css('--block-link-p-height', $p.outerHeight() + 'px');
		}
	})
})

$('.nav-sidebar-inner > li').on('mouseenter', function () {
    var $childList = $(this).find('> ul');
    if ($childList.length > 0) {
        var childRect = $childList[0].getBoundingClientRect();
        if (childRect.top < 125) {
            $childList.css('bottom', -(125 - childRect.top) + 'px');
        }
    }
}).on('mouseleave', function () {
    var $childList = $(this).find('> ul');
    if ($childList.length > 0) {
        $childList.css('bottom', 0);
    }
});

// SMOOTH SCROLL
function smooth_scroll( $elem, speed ) {
	if( speed == undefined ) speed = 500;
	if( $elem.length > 0 ) {
		$('html,body').animate({
			'scrollTop': $elem.offset().top - $('header.primary').outerHeight()
		}, speed, 'linear');
	}
}

function get_url_param(name) {
	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
	var results = regex.exec(location.search);
	return results === null ? false : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

// OPEN IN NEW TAB FOR PDF LINKS
$('a[href*=".pdf"').attr('target','_blank');


// TOOLTIP
if( get_url_param( 'tooltip' ) ) {
	$(document).on('mouseenter', '[data-tooltip]', function(){
		if( $(this).attr('data-tooltip') ) {
			if( $(this).find('.tooltip').length == 0 ) {
				$(this).attr('data-tooltip-init', 'true');
				$(this).prepend('<div class="tooltip-wrapper"><div class="tooltip">' + $(this).attr('data-tooltip') + '</div></div>');
			}
			var wwidth = $(window).width();
			$(this).find('.tooltip-wrapper').removeClass('tooltip--page-left tooltip--page-right');
			if( $(this).find('.tooltip').offset().left < 0 ) {
				$(this).find('.tooltip-wrapper').addClass('tooltip--page-left');
			} else if( ( $(this).find('.tooltip').offset().left + $(this).find('.tooltip').outerWidth() ) > wwidth ) {
				$(this).find('.tooltip-wrapper').addClass('tooltip--page-right');
			}
		}
	}).on('mouseleave', function(){
		$(this).find('.tooltip-wrapper').removeClass('tooltip--page-left tooltip--page-right');
	})
}